var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[_c('f7-navbar',{attrs:{"title":"EZMeals 行動點餐"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }